// product-gallery.js

(function() {
  'use strict';

  // 在DOM加载完成后初始化组件
  document.addEventListener('DOMContentLoaded', function() {
    PGA_v7r_initProductGallery();
  });

  /**
   * 初始化产品图库组件
   */
  function PGA_v7r_initProductGallery() {
    // 产品图库容器
    const pga_v7r_galleryContainers = document.querySelectorAll('[data-pga-product-gallery-container]');
    
    if (!pga_v7r_galleryContainers.length) return;
    
    pga_v7r_galleryContainers.forEach(function(pga_v7r_gallery) {
      const pga_v7r_productSection = pga_v7r_gallery.closest('.product-section');
      
      if (!pga_v7r_productSection) return;
      
      // 监听产品变体变化事件
      pga_v7r_productSection.addEventListener('variant:change', function(event) {
        if (!event.detail || !event.detail.variant) return;
        
        const pga_v7r_variant = event.detail.variant;
        
        // 切换变体图片，如果有的话
        if (pga_v7r_variant.featured_media) {
          const pga_v7r_mediaId = pga_v7r_variant.featured_media.id;
          const pga_v7r_slideSelector = '[data-pga-product-single-media-group] [data-pga-media-id="' + pga_v7r_mediaId + '"]';
          const pga_v7r_slideElement = pga_v7r_productSection.querySelector(pga_v7r_slideSelector);
          
          if (pga_v7r_slideElement) {
            // 使用Shopify的滑块API切换到对应的幻灯片
            if (window.Shopify && window.Shopify.theme && window.Shopify.theme.productMedia) {
              const pga_v7r_productMedia = window.Shopify.theme.productMedia;
              const pga_v7r_sectionId = pga_v7r_productSection.getAttribute('data-section-id');
              
              if (pga_v7r_productMedia && pga_v7r_productMedia.models && pga_v7r_productMedia.models[pga_v7r_sectionId]) {
                const pga_v7r_mediaModel = pga_v7r_productMedia.models[pga_v7r_sectionId];
                
                if (pga_v7r_mediaModel.imageCarousel) {
                  const pga_v7r_mediaIndex = parseInt(pga_v7r_slideElement.getAttribute('data-pga-index'));
                  pga_v7r_mediaModel.imageCarousel.select(pga_v7r_mediaIndex);
                }
              }
            }
          }
        }
      });
    });
  }
})(); 